import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../../../shared/services/common.service';
import { API_ENDPOINTS } from '../../../../core/services/api.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DataPatchingRecallService {

  constructor(public commonSvc: CommonService, private http: HttpClient) { }

  dataPatching(data: any): Observable<any>{
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.REPORT.DATA_PATCHING, data)
  }
  dataRecall(data: any): Observable<any>{
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.REPORT.DATA_RECALL, data)
  }
  getAllSensors(): Observable<any>{
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.DEVICE_MANAGEMENT.SENSORS.GET_ALL_DEVICES)
  }
}
